import { useCallback } from "react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import PlayerForm, { PlayerFormValues } from "./PlayerForm";

const EditProfileSettings = () => {
  //TODO: load current user data

  const submitHandler = useCallback((values: PlayerFormValues) => {
    alert(JSON.stringify(values));
  }, []);

  return (
    <Card>
      <CardHeader className="p-2">
        <CardTitle className="text-center">Edit Profile</CardTitle>
      </CardHeader>

      <CardContent className="overflow-hidden">
        <PlayerForm onSubmit={submitHandler} />
      </CardContent>
    </Card>
  );
};

export default EditProfileSettings;
